const channel = new BroadcastChannel('intercom-sync');

export function setupIntercomSync() {
  channel.onmessage = event => {
    if (event.data?.type === 'intercom-close') {
      window.Intercom?.('hide');
    }
  };
}

export function notifyIntercomClose() {
  channel.postMessage({ type: 'intercom-close' });
}
